import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import * as RfqActions from "./actions";
import type { IRfqReducerState } from "./types";

const initialRfqReducerState: IRfqReducerState = {
  rfq: null!,
  rfqStatus: null!,
  isFetching: false,
  isSubmitting: false,
  hasError: false,
  errorStatusCode: 0
};

export default function rfqReducer(state: IRfqReducerState = initialRfqReducerState, action: ActionType<typeof RfqActions>): IRfqReducerState {
  switch (action.type) {
    case getType(RfqActions.fetchRfqStart): {
      const baseState = state.rfq && state.rfq.id === action.payload ? state : initialRfqReducerState;
      return { ...baseState, isFetching: true };
    }

    case getType(RfqActions.fetchRfqSuccess):
      return { ...state, isFetching: false, hasError: false, errorStatusCode: 0, rfq: action.payload };

    case getType(RfqActions.fetchRfqFail):
    case getType(RfqActions.startRfqFail):
      return { ...state, isFetching: false, hasError: true, errorStatusCode: action.payload.statusCode || 0 };

    case getType(RfqActions.submitRfq):
      return { ...state, isSubmitting: true };

    case getType(RfqActions.submitRfqSuccess):
      return { ...state, isSubmitting: false, rfqStatus: "success" };

    case getType(RfqActions.submitRfqFail):
      return { ...state, isSubmitting: false, rfqStatus: "error" };

    default:
      return state;
  }
}
